// Module
var code = `<div class="loan-preview">
  <div id="uid-accordion" class="accordion amortization-accordion" ng-if="\$ctrl.uidLedger">
      <table class="table">
        <thead>
        <tr>
          <th>No</th>
          <th>Date</th>
          <th>Days</th>
          <th>Income</th>
          <th>Unearned Interest</th>
          <th>Balance</th>
          <th ng-if="\$ctrl.showStatus">Status</th>
        </tr>
        </thead>
        <tbody class="tbody">
        <tr ng-repeat="item in \$ctrl.uidLedger.list">
          <td>{{item.lineNumber}}</td>
          <td>{{item.date | prettyDate }}</td>
          <td>{{item.days}}</td>
          <td>{{item.income | nxCurrency:'dashOnZero'}}</td>
          <td>{{item.unearnedInterest | nxCurrency:'dashOnZero'}}</td>
          <td>{{item.balance | nxCurrency:'dashOnZero'}}</td>
          <td ng-if="\$ctrl.showStatus">{{item.status | prettyEnum}}</td>
        </tr>
        <tr>
          <td>
            <strong>
              Total:
            </strong>
          </td>
          <td></td>
          <td>{{\$ctrl.uidLedger.totalDays}}</td>
          <td>{{\$ctrl.uidLedger.totalIncome | nxCurrency:'dashOnZero'}}</td>
          <td>{{\$ctrl.uidLedger.totalUnearnedInterest | nxCurrency:'dashOnZero'}}</td>
          <td></td>
          <td ng-if="\$ctrl.showStatus"></td>
        </tr>
        </tbody>
      </table>
    </div>
</div>`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/customer/loans/common/uid-ledger.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;